// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ALLOWED_EMAILS = ["kunwar@embaiimu.in", "kunwarpratap.singh.emba2025@iimu.ac.in"];

export default function ProtectedRoute({ user, children }) {
  if (!user) {
    // Not logged in
    return <Navigate to="/login" replace />;
  }

  if (!ALLOWED_EMAILS.includes(user.username)) {
    // Logged in but not authorized
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Access Denied</h2>
        <p>Your account does not have permission to access this page.</p>
      </div>
    );
  }

  // Authorized
  return children;
}